
import { Component, Inject, OnDestroy, OnInit, Renderer2, DOCUMENT } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DescriptionParserService } from 'app/core/services/parse-description.service';
import { Item, Menu } from '../../models/menu.model';
import { MenuService } from './../../services/menu.service';

@Component({
    selector: 'app-item-detail',
    templateUrl: './item-detail.component.html',
    styleUrls: ['./item-detail.component.scss'],
    standalone: false
})
export class ItemDetailComponent implements OnInit, OnDestroy {
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  /**
   * Identificador del color del texto
   */
  color = '';
  /**
   * Constructor
   *
   * @param dialogRef servicio para abrir modal
   * @param data informacion del item
   */
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private menuService: MenuService,
    public descriptionParser: DescriptionParserService,
    public dialogRef: MatDialogRef<ItemDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { item: Item; menu: Menu; color: string }) {
    this.renderer.addClass(this.document.body, 'embedded-body');
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'embedded-body');
  }
  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
    this.color = this.data.color;
  }


  /**
   * Cierra el modal
   */
  close(): void {
    this.dialogRef.close();
  }

  /**
   * Indica si el producto tiene imagen o no
   *
   * @param item producto a evaluar
   * @returns boolean
   */
  hasImage(item: Item): boolean {
    if (item.photo && item.photo !== '' && !item.hiddenPhoto) {
      if (item.photo.length > 0) {
        return true;
      }
    }

    return false;

  }

}
